// extracted by mini-css-extract-plugin
module.exports = {"title":"IndexPage_title__39oWV","assembleia":"IndexPage_assembleia__2KB_x","switch":"IndexPage_switch__4Ihgx","slider":"IndexPage_slider__Cp97E","on":"IndexPage_on__UoPZG"};